import { StyledIcon } from "@insite/mobius/Link";
import ClipboardIcon from "@midland-industries/Icons/ClipboardIcon";
import React from "react";

const CopyButton = ({ value, style }: { value: string; style?: React.CSSProperties }) => {
    return (
        <StyledIcon
            style={{ cursor: "pointer", ...style }}
            src={ClipboardIcon}
            size={24}
            onClick={() => navigator.clipboard.writeText(value)}
        />
    );
};

export default CopyButton;
